import React from 'react';

//CORE COMPONENTS
import {
    styled
} from '../../../components-core/packages/components-core/dist/theme-provider/index';
import {
    Container,
    ContainerWrap,
    ContainerPadding,
    ContainerVerticalAlignment,
    ContainerHorizontalAlignment,
    ContainerGutter,
} from '../../../components-core/packages/components-core/dist/container/index';
import { Layout } from '../../../components-core/packages/components-core/dist/layout/index';
import {
    Text,
    TextAppearance,
    TextColor
} from '../../../components-core/packages/components-core/dist/text';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { Image } from '../../../components-core/packages/components-core/dist/image/index';

//ICONS CORE
import { Clock } from '../../../components-core/packages/icons-core/dist/Clock/index';


const TopContainer = styled.div`
    width: 100vw;
`;

const Line = styled.hr`
    width: 32px;
    height: 2px;
    background-color: #001e50;
    display: ${props => !props.isSelected && ('none')};

`;

const LineTwo = styled.hr`
width : 0;
height: 1px;
background-color:#ffffff;
color: #ffffff;
margin-bottom:-2px;
`;

const CustomButton = styled.div`
    cursor: pointer;
`;


class TabGallery extends React.Component {

    constructor() {
        super();
        this.state = {
            selectedIndex: 0
        }
    }

    renderTopView() {

        const padding = {
            [Breakpoints.default]: null,
            [Breakpoints.b560]: ContainerPadding.grid003,
            [Breakpoints.b1600]: ContainerPadding.dynamic0150,
            [Breakpoints.b1920]: ContainerPadding.grid003
        }

        return (
            <Container stretchContent={false} padding={{ left: padding }} >
                <Text appearance={TextAppearance.headline0350}>
                    Yeni zorluklara karşı her zaman <br />
                    <Text bold>
                        {' uyum sağlar.'}
                    </Text>
                </Text>
            </Container>
        )
    }

    renderIcons() {
        const horizontalAlign = {
            [Breakpoints.default]: ContainerHorizontalAlignment.flexStart,
            [Breakpoints.b1280]: ContainerHorizontalAlignment.center
        }

        const icons = iconList(this.props);
        const renderedIcons = icons.map((data, index) => data.title &&
            <CustomButton onClick={() => this.setState({ selectedIndex: index })}
            >
                <Container
                    gutter={ContainerGutter.dynamic0020}
                    horizontalAlign={ContainerHorizontalAlignment.center}
                    appearance={TextAppearance.label0150}
                    wrap={ContainerWrap.always}
                    gutter={ContainerGutter.static150}
                >
                    <Container
                        wrap={{ [Breakpoints.default]: ContainerWrap.always, [Breakpoints.b1280]: ContainerWrap.never }}
                        gutter={ContainerGutter.dynamic0020}
                        horizontalAlign={ContainerHorizontalAlignment.flexStart}
                        verticalAlign={ContainerVerticalAlignment.center}
                    >

                        {(this.state.selectedIndex === index) ? <Image width={'32px'} height={'32px'} src={data.icon} /> : <Image width={'32px'} height={'32px'} src={data.icong} />}
                        <Text> </Text>
                        {this.renderTabText(data)}
                    </Container>
                    <Container horizontalAlign={horizontalAlign}>
                        <Line isSelected={this.state.selectedIndex === index} />
                    </Container>
                </Container>
            </CustomButton>
        )

        return (
            <Container
                wrap={ContainerWrap.never}
                horizontalAlign={ContainerHorizontalAlignment.center}
                gutter={ContainerGutter.dynamic0100}
            >
                {renderedIcons}
            </Container>
        )
    }

    renderTabText(data) {
        const isMobile = typeof window !== `undefined` && window.innerWidth <= 768;

        if (isMobile) {
            return (
                <Text>{data.title.split(' ')[0]}<br />{data.title.split(' ')[1]}</Text>

            )
        } else {
            return (<Text>{data.title}</Text>);
        }
    }

    renderDescription() {
        const padding = {
            [Breakpoints.b560]: ContainerPadding.grid002,
            [Breakpoints.b960]: ContainerPadding.grid004,
            [Breakpoints.b1280]: ContainerPadding.grid006
        }

        const icons = iconList(this.props);

        return (
            <Container
                horizontalAlign={ContainerHorizontalAlignment.center}
                padding={{ left: padding, right: padding }}
            >
                <Text>
                    {icons[this.state.selectedIndex].desc}
                </Text>
            </Container>
        )
    }

    renderImageSection() {
        const icons = iconList(this.props);
        let size = icons[this.state.selectedIndex].title.split(' ').length
        const isMobile = typeof window !== `undefined` && window.innerWidth <= 768;
        if(size>1 && isMobile) {
            return(
                    <Container
                        stretchContent={true}
                        gutter={ContainerGutter.dynamic0120}
                        wrap={ContainerWrap.always}
                    >
                        {this.renderIcons()}
                        <LineTwo/>
                        <Image
                            src={icons[this.state.selectedIndex].photo}
                            alt={'vw-ustten-kesit'}
                        />
                        
                    </Container>
                )
            
        }else  if(size==1 && isMobile) {
            return(
                    <Container
                        stretchContent={true}
                        gutter={ContainerGutter.dynamic0120}
                        wrap={ContainerWrap.always}
                    >
                        {this.renderIcons()}
                        <br/>
                        <Image
                            src={icons[this.state.selectedIndex].photo}
                            alt={'vw-ustten-kesit'}
                        />
                        
                    </Container>
                )
            
        }
        else {
            return (
                <Container
                    stretchContent={true}
                    gutter={ContainerGutter.dynamic0120}
                    wrap={ContainerWrap.always}
                >
                    {this.renderIcons()}
                    <Image
                        src={icons[this.state.selectedIndex].photo}
                        alt={'vw-ustten-kesit'}
                    />
                </Container>
            )
        }
    }

    render() {
        return (
            <TopContainer>
                <Layout appearance={layoutBreakpoints}>
                    <Container
                        padding={{ top: ContainerPadding.dynamic0200, bottom: ContainerPadding.dynamic0200 }}
                        wrap={ContainerWrap.always}
                        gutter={ContainerGutter.dynamic0200}
                    >
                        {this.renderTopView()}
                        {this.renderImageSection()}
                        {this.renderDescription()}
                    </Container>
                </Layout>
            </TopContainer>
        )
    }
}

export default TabGallery;

const layoutBreakpoints = {
    [Breakpoints.default]: [
        { name: '.', columns: 2 },
        { name: 'a', columns: 20 },
        { name: '.', columns: 2 }
    ],
    [Breakpoints.b1600]: [
        { name: '.', columns: 4 },
        { name: 'a', columns: 16 },
        { name: '.', columns: 4 }
    ]
}

const iconList = (props) => [
    {
        title: props.custom4,
        icon: props.custom12,
        photo: props.custom,
        desc: props.custom8,
        icong: props.custom15,
    },
    {
        title: props.custom5,
        icon: props.custom13,
        photo: props.custom1,
        desc: props.custom9,
        icong: props.custom16,

    },
    {
        title: props.custom6,
        icon: props.custom14,
        photo: props.custom2,
        desc: props.custom10,
        icong: props.custom17,

    }
]